import styled from "styled-components";
import { media } from "../../utils/styles/media";
import { colors } from "../../utils/styles/colors";
import { networkRanges } from "../../utils/styles/networks";

export const InfluencerProfileContainer = styled.div`

    font-family: 'Open Sans',  sans-serif;
    .banner{
        background-color: #000000;
        display: flex;
        flex-direction: column;
        padding: 30px 50px ;
        min-height: 600px;
        .goBack{
            display: flex;
            margin-bottom: 20px;
            margin-left: 50px;
            cursor: pointer;
            width: 230px;
            .backIcon{
                width: 40px;
                margin-right: 15px;
            }
            .backText{
                color: #ffffff;
                font-size: 2.5rem;
                font-weight: 500;
            }
        }
        .bannerInformation{
            display: flex;
            justify-content: space-between;
            .networkContainer{
                color: #ffffff;
                display: flex;
                position: relative;
                .play{
                    position: absolute;
                    z-index: 100;
                    width : 120px;
                    height:120px;
                    border-radius: 50%;
                    top:590px;
                    left: 265px;
                    cursor: pointer;
                }
                .networks{
                    position: relative;
                    text-align: end;
                    left: 430px;
                    width: 800px;
                    margin-top: 10px;
                    .networkLine{
                        display: flex;
                        align-items: center;
                        span{
                            font-weight: 700;
                            font-size:2.2rem;
                            white-space: nowrap;
                        }
                    }
                    .youtubeCount, .twitterCount, .tiktokCount, .facebookCount, .instagramCount{
                        display: flex;
                        justify-content: flex-end;
                        align-items: center;
                        margin: 8px 0 5px;
                        hr{
                            width: calc(100% - 57px);;
                            border: 3px solid #ffffff;
                        } 
                        svg{
                            width: 60px;
                            height: 60px;
                            margin-right: 10px; 
                        }
                        span{
                            font-weight: 700;
                            font-size: 2.8rem;
                            white-space: nowrap;
                        }
                    }
                    .facebookCount{
                        hr{
                            margin-bottom:3px;
                        }
                        svg{
                            margin-left: -14px;
                            margin-right: 1px;
                            margin-top: 3.2px;   
                        }
                    }
                    .tiktokCount{
                        svg{
                            margin-left: -7px;
                        }
                    }
                    .twitterCount{
                        svg{
                            margin-left: -10px;
                        }
                    }
                    .youtubeCount:hover{
                        hr{
                            border-color: red;
                        }
                        span{
                            color: red;
                        }
                        svg{
                            path{
                                fill:red;
                            }
                        }
                    }
                    .twitterCount:hover{
                        hr{
                            border-color: ${colors.twitter};
                        }
                        span{
                            color: ${colors.twitter};
                        }
                        svg{
                            path{
                                fill:${colors.twitter};
                            }
                        }
                    }
                    .facebookCount:hover{
                        hr{
                            border-color: ${colors.facebook};
                        }
                        span{
                            color: ${colors.facebook};
                        }
                        svg{
                            path{
                                fill:${colors.facebook};
                            }
                        }
                    }
                    .instagramCount:hover{
                        hr{
                            border-color: ${colors.hightlight};
                        }
                        span{
                            color: ${colors.hightlight};
                        }
                        svg{
                            path{
                                fill:${colors.hightlight};
                            }
                        }
                    }
                    .tiktokCount:hover{
                        hr{
                            border-color: ${colors.tiktok};
                        }
                        span{
                            color: ${colors.tiktok};
                        }
                        svg{
                            path.principal{
                                stroke-width: 0px;
                            }
                            path.magenta{
                                    fill:${colors.tiktok2};
                                    stroke-width: 0px;
                                }
                            path.rosa{
                                    fill:${colors.tiktok};
                                }
                        }
                    }
                }
            }
            .data{
                margin-right: 50px;
                width: 1000px;
                font-family: 'Open Sans',  sans-serif;
                .fileName{
                    display: flex;
                    //align-items: center;
                    align-items: baseline;
                    .name{
                        color: #ffffff;
                        font-size: 4rem;
                        font-weight: bold;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        max-width: 85%;
                    }
                    .checkContainer{
                        background-color: #000000;
                        width: 35px;
                        border-radius: 50%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        margin-left: 25px; 
                        .check{
                            width: 100%;
                            height: 100%;
                        }
                    }  
                    .likeInfluencerContainer{
                        margin-left: 25px;
                        width: 60px;
                        height: 60px;
                    }
                    .likeCompanyContainer{
                        width: 40px;
                        display: flex;
                        align-items: flex-end;
                        margin-left: 20px;
                    }               

                }
                .firstFile, .lastFile{
                    display: flex;
                    //align-items: center;
                    position: relative;
                    margin-top: 5px;
                    .star{
                        margin-left: 10px;
                        margin-right: 35px;
                        width: 30px;
                        height: 30px;
                        cursor: pointer;
                    }
                    
                    .item{
                        display: flex;
                        align-items: center;
                        .city{
                            color: ${colors.hightlight};
                            //font-size: 2.5rem;
                            font-size: 2.3rem;
                            font-weight: 600;
                            margin-right: 10px;
                        }
                    }
                    .items{
                        display: flex;
                        align-items: flex-start;
                        //align-items: center;
                        .share{
                            position: relative;
                            margin-left: 25px;
                            margin-top: 7px;
                            cursor: pointer;
                            .shareIcon{
                                width: 35px;
                                height: 35px;
                                cursor: pointer;
                            }
                        }
                        .subItem{
                            display: flex;
                            position: relative;
                            align-items: center;
                            .language{
                                color: #ffffff;
                                //margin-right: 20px;
                                margin-left: 10px;
                                font-size: 2.5rem;
                                span{
                                    white-space: nowrap
                                }
                                
                            }
                            .score{
                                color: #ffffff;
                                font-size: 2.5rem;
                                margin-left: 25px;
                            }
                        }
                        
                    }

                    .categories{
                        color: ${colors.hightlight};
                        text-align: center;
                        text-transform: lowercase;
                        font-weight: 600;
                        font-size: 2.4rem;
                    }

                }
                .descriptionContainer{
                    margin: 15px 0;
                    display: flex;
                    align-items: flex-end;
                    color: #ffffff;
                    
                    .descriptionEmpty{
                        width: 100%;
                        .item{
                            hr{
                                margin-top: 40px;  
                            }
                            hr:first-child{
                                margin-top: 5px;  
                            }
                        }

                    }
                    .descriptionContent{
                        max-height: 160px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        inline-size: 100%;
                        overflow-wrap: break-word; 
                        p{
                            font-weight: lighter;
                            font-size: 2.4rem;
                        }
                    }                   
                }
                .lastFile{
                    margin-top: 5px;
                }

            }
            .networkMobile{
                display: none;
            }
        }
    }
    .myProfileBody{
        min-height: 600px;
        padding:30px 95px 30px 95px ;
        
        .collaborationsCardsContainer, .galeryCardsContainer,  .productsCardsContainer{
            margin-top: 30px;
            .title{
                display: flex;
                justify-content: space-between;
                margin-bottom: 10px;
                h3{
                    font-size: 3.5rem;
                    color: ${colors.title};
                }
                /* .more{
                    align-self: flex-end;
                    font-weight: bold;
                    font-size: 1.1rem;
                    color: ${colors.text};
                    text-decoration: underline;
                    font-family: 'Centrale', sans-serif;
                } */
            }
            
            .collaborationCards, .galeryCards, .productsCards{
                display: flex;
                flex-wrap: wrap;
                .front{
                    width: 23%;
                    height: 21vw;
                    background-repeat: no-repeat;
                    background-position: 50% 50%;
                    background-size: cover;
                    position: relative;
                    margin: 0 2% 2% 0;
                    .companyIcon{
                        width: 70px;
                        height: 70px;
                        position: absolute;
                        bottom: 20px;
                        right: 20px;
                        border-radius: 50%;
                    }
                    .likeProductContainer{
                        position: absolute;
                        top: 25px;
                        right: 25px;
                        width: 60px;
                        height: 60px;
                        
                    }                   
                    .productName{
                        width: 100%;
                        background-color: rgba(61, 61, 61, 0.5);
                        text-align: center;
                        color: #ffffff;
                        padding: 10px 12px;
                        text-transform: capitalize;
                        position: absolute;
                        bottom: 0px;
                        right: 0px;
                        //font-size: 2.6rem;
                        //font-size: 2.4rem;
                        font-size: 2.2rem;
                        font-weight: bold;
                        a{
                            color: #ffffff;
                        }
                        a:visited{
                            color: #ffffff;
                        }
                        p{
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            width: 100%;
                        }
                    }
                }
                .notContent{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    height: 400px;
                    width: 100%;
                    p{
                        font-size: 1.8rem;
                    }
                    
                }
            }
            /* .galeryCards{
                -webkit-mask-image: linear-gradient(to bottom, rgba(0,0,0,1), rgba(0,0,0,0));
                -webkit-mask-size: 100% 100%;
                -webkit-mask-repeat: no-repeat;
                -webkit-mask-position: left top,  left bottom;
            } */
            .noContent{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    height:150px;
            }
            .more{
                    display: flex;
                    justify-content: center;
                    font-weight: bold;
                    font-size: 1.1rem;
                    color: ${colors.hightlight};
                    text-decoration: underline;
                    font-family: 'Centrale', sans-serif;
            }
            
        }
        .productsCardsContainer{
            //margin-top: 250px;
            margin-top: 200px;
                  
        }
    }

    /**----------Responsive---------- */
    ${media.extralargeDesktop}{
        .banner{
            min-height: 550px;
            .bannerInformation{
                margin-top: 30px;
                .networkContainer{
                    .play{
                        width : 110px;
                        height: 110px;
                        top:495px;
                        left: 220px;
                    }
                    .networks{
                        left: 375px;
                        width: 520px;
                        .networkLine{
                            span{
                                font-size:2rem;
                            }
                        }
                        .youtubeCount, .twitterCount, .tiktokCount, .facebookCount, .instagramCount{
                            hr{
                                //width: 54%;
                                width: calc(100% - 48px);
                                border: 2.5px solid #ffffff;
                            } 
                            svg{
                                width: 50px;
                                height: 50px;
                                margin-right: 10px; 
                            }
                            span{
                                font-size: 2.4rem;
                            }
                        }
                        .facebookCount{
                            svg{
                               // margin-right: 0px;
                            }
                        }
                    }
                }
                .data{
                    width: 830px;
                    .fileName{
                        .name{
                            font-size: 3.5rem;
                        }
                    }
                }
            }
        }
        
    }

    ${media.largeDesktop}{
        .banner{
            min-height: 450px;
            padding: 30px 30px ;
            .goBack{
                width: 180px;
                margin-left: 50px;
                .backIcon{
                    width: 35px;
                }
                .backText{
                    font-size: 1.8rem;
                }
            }
            .bannerInformation{
                .networkContainer{
                    .play{
                        width : 90px;
                        height: 90px;
                        top:405px;
                        left: 180px;
                    }
                    .networks{
                        left: 313px;
                        width: 470px;
                        .youtubeCount, .twitterCount, .tiktokCount, .facebookCount, .instagramCount{
                            svg{
                                width: 45px;
                                height: 45px;
                            }
                            span{
                                font-size: 2rem;
                            }
                        }
                        .facebookCount{
                            svg{
                               // margin-right: 0px;
                            }
                        }
                    }
                }
                .data{
                    width: 760px;
                    .fileName{
                        .name{
                            font-size: 3.3rem;
                        }
                        .checkContainer{
                            width: 30px;
                        }  
                        .likeInfluencerContainer{
                            width: 45px;
                            height: 45px;
                        }
                        .likeCompanyContainer{
                            width: 35px;
                        }               
                    }
                    .firstFile, .lastFile{
                        .item{
                            .city{
                                //font-size: 1.9rem;
                                font-size: 1.8rem;
                            }
                            
                        }
                        .items{
                            .share{
                                margin-top: 5px;
                                .shareIcon{
                                    width: 29px;
                                    height: 29px;
                                }
                            }
                            .subItem{
                                .language{
                                font-size: 1.9rem;
                                font-size: 1.8rem;
                                }
                                .score{
                                    font-size: 1.9rem;
                                    font-size: 1.8rem;
                                }
                                .star{
                                    width: 25px;
                                    height: 25px;
                                }
                            }
                        }
                        .categories{
                            font-size: 1.8rem;
                            font-size: 1.8rem;
                        }
                    }
                    .descriptionContainer{
                        .descriptionEmpty{
                            width: 100%;
                            .item{
                                hr{
                                    margin-top: 30px;  
                                }
                                hr:first-child{
                                    margin-top: 5px;  
                                }
                            }

                        }
                        .descriptionContent{
                            max-height: 117px;
                            p{
                                font-size: 1.8rem;
                                font-size: 1.7rem;
                            }
                        } 
                    }
                }
            }
        }
        .myProfileBody{
            padding:30px 80px 30px 80px;
            .collaborationsCardsContainer, .galeryCardsContainer,  .productsCardsContainer{ 
                .title{
                    h3{
                        font-size: 2.6rem;
                    }
                }
                .collaborationCards, .galeryCards, .productsCards{
                    .front{
                        .likeProductContainer{
                            top: 20px;
                            right: 20px;
                            width: 50px;
                            height: 50px;
                            
                        }
                        .productName{
                            padding: 8px 10px;
                            //font-size: 2rem;
                            font-size: 1.8rem;
                        }
                    }
                    .notContent{
                        height: 350px;
                        p{
                            font-size: 1.5rem;
                        }
                    }
                }
            }
            .productsCardsContainer{
                //margin-top: 200px;
                margin-top: 190px;   
            }
        }
    }

    ${media.specialScreen}{
        .banner{
            min-height: 400px;
            padding: 30px 30px ;
            .goBack{
                width: 160px;
                .backIcon{
                    width: 28px;
                }
                .backText{
                    font-size: 1.4rem;
                }
            }
            .bannerInformation{
                .networkContainer{
                    .play{
                        width : 70px;
                        height: 70px;
                        top:345px;
                        left: 155px;
                    }
                    .networks{
                        width: 500px;
                        left: 270px;
                        .networkLine{
                            align-items: flex-end;
                            span{
                                font-size:1.6rem;
                            }
                        }
                        .youtubeCount, .twitterCount, .tiktokCount, .facebookCount, .instagramCount{
                            margin-top: 10px;
                            svg{
                                width: 40px;
                                height: 40px;
                            }
                            span{
                                font-size: 1.6rem;
                            }
                        }
                        .facebookCount{
                            svg{
                                //margin-right: 0px;
                            }
                        }
                    }
                }
                .data{
                    width: 590px;
                    .fileName{
                        .name{
                            font-size: 2.5rem;
                        }
                        .checkContainer{
                            width: 25px;
                        }  
                        .likeInfluencerContainer{
                            width: 40px;
                            height: 40px;
                        }
                        .likeCompanyContainer{
                            width: 40px;
                        }               
                    }
                    .firstFile, .lastFile{
                        .item{
                            .city{
                                font-size: 1.4rem;
                            }
                            
                        }
                        .items{
                            .share{
                                .shareIcon{
                                    width: 21px;
                                    height: 21px;
                                }
                            }
                            .subItem{
                                .language{
                                font-size: 1.4rem;
                                }
                                .score{
                                    font-size: 1.4rem;
                                }
                                .star{
                                    width: 21px;
                                    height: 21px;
                                }
                            }
                        }
                        .categories{
                            font-size: 1.3rem;
                        }
                    }
                    .descriptionContainer{
                        .descriptionEmpty{
                            width: 100%;
                            .item{
                                hr{
                                    margin-top: 30px;  
                                }
                                hr:first-child{
                                    margin-top: 5px;  
                                }
                            }

                        }
                        .descriptionContent{
                            p{
                                font-size: 1.3rem;
                            }
                        } 
                    }
                }
            }
        }
        .myProfileBody{
            .collaborationsCardsContainer, .galeryCardsContainer,  .productsCardsContainer{ 
                .collaborationCards, .galeryCards, .productsCards{
                    .front{
                        .likeProductContainer{
                            top: 15px;
                            right: 15px;
                            width: 40px;
                            height: 40px;   
                        }
                        .productName{
                            padding: 5px 8px;
                            //font-size: 1.8rem;
                            font-size: 1.6rem;
                        }
                    }
                    .notContent{
                        height: 300px;
                        p{
                            font-size: 1.3rem;
                        }
                    }
                }
            }
            .productsCardsContainer{
                margin-top: 150px;
                    
            }
        }
    }

    ${media.bigmacdesktop}{
        .banner{
            min-height: 380px;
            .goBack{
                width: 140px;
                margin-left: 40px;
                .backIcon{
                    width: 26px;
                }
                .backText{
                    font-size: 1.2rem;
                }
            }
            .bannerInformation{
                .networkContainer{
                    .play{
                        width : 60px;
                        height: 60px;
                        top:330px;
                        left: 150px;
                    } 
                    .networks{
                        left: 240px;
                        width: 480px;
                        .networkLine{
                            span{
                                font-size:1.3rem;
                            }
                        }
                        .youtubeCount, .twitterCount, .tiktokCount, .facebookCount, .instagramCount{
                            margin-top: 10px;
                            hr{
                                //width: 57%;
                                border: 2.5px solid #ffffff;
                            }
                            svg{
                                width: 35px;
                                height: 35px;
                            }
                            span{
                                font-size: 1.4rem;
                            }
                        }
                        .youtubeCount{
                            
                        svg{
                            margin-left: -1px;
                        }
                    
                        }
                    }
                }
                .data{
                    width: 560px;
                    .fileName{
                        .name{
                            font-size: 2.4rem;
                        }
                        .checkContainer{
                            width: 24px;
                        }  
                        .likeInfluencerContainer{
                            width: 38px;
                            height: 38px;
                        }
                        .likeCompanyContainer{
                            width: 38px;
                        }               
                    }
                }
            }
        }
        .myProfileBody{
            .collaborationsCardsContainer, .galeryCardsContainer,  .productsCardsContainer{ 
                .collaborationCards, .galeryCards, .productsCards{
                    .front{
                        .productName{
                            font-size: 1.5rem;
                        }
                    }
                }
            }
            .productsCardsContainer{
                margin-top: 120px;
                    
            }
        }
        
    }

    ${media.macdesktop}{
        .banner{
            min-height: 350px;
            .goBack{
                width: 130px;
                margin-left: 40px;
                .backIcon{
                    width: 24px;
                }
                .backText{
                    font-size: 1.1rem;
                }
            }
            .bannerInformation{
                .networkContainer{
                    .play{
                        width : 55px;
                        height: 55px;
                        top:312.5px;
                        left: 142.5px;
                    } 
                    .networks{
                        left: 235px;
                        width: 420px;
                        .youtubeCount, .twitterCount, .tiktokCount, .facebookCount, .instagramCount{
                            hr{
                               // width: 57%;
                               width: calc(100% - 30px);
                                border: 2.2px solid #ffffff;
                            }
                            svg{
                                width: 32px;
                                height: 32px;
                            }
                            span{
                                font-size: 1.3rem;
                            }
                        }
                    }
                }
                .data{
                    width: 530px;
                    .firstFile, .lastFile{ 
                        .item{
                            .city{
                                font-size: 1.3rem;
                            }
                            
                        }
                         .items{
                            .share{
                                margin-left: 20px;
                                margin-top: 2px;
                                .shareIcon{
                                    width: 19px;
                                    height: 19px;
                                }
                            }
                            .subItem{
                                .language{
                                    font-size: 1.3rem;
                                }
                                .score{
                                    margin-left: 20px;
                                } 
                                .star{
                                    width: 21px;
                                    height: 21px;
                                    margin-left: 6px;
                                    margin-right: 0px;
                                }
                            }
                        } 
                        .categories{
                            font-size: 1.2rem;
                        } 
                    }
                    .descriptionContainer{   
                        .descriptionContent{
                            max-height: 115px;
                        } 
                    }
                }
            }
        }
        .myProfileBody{
            .collaborationsCardsContainer, .galeryCardsContainer,  .productsCardsContainer{ 
                .title{
                    h3{
                        //font-size: 2.4rem;
                    }
                }
                .collaborationCards, .galeryCards, .productsCards{
                    .front{
                        .productName{
                            //font-size: 1.6rem;
                            font-size: 1.4rem;
                        }
                    }
                }
            }
            .productsCardsContainer{
                margin-top: 80px;
                    
            }
        }
    }

    ${media.desktop}{
        .banner{
            min-height: 310px;
            padding: 20px 20px ;
            .goBack{
                width: 120px;
                margin-left: 40px;
                .backIcon{
                    width: 20px;
                }
                .backText{
                    font-size: 1rem;
                }
            }
            .bannerInformation{
                .networkContainer{
                    .play{
                        width : 50px;
                        height: 50px;
                        top:275px;
                        left: 125px;
                    } 
                    .networks{
                        left: 205px;
                        width: 380px;
                        .networkLine{
                            span{
                                font-size:1.1rem;
                            }
                        }
                        .youtubeCount, .twitterCount, .tiktokCount, .facebookCount, .instagramCount{
                            hr{
                                //width: 57%;
                                width: calc(100% - 26px);
                                border: 2px solid #ffffff;
                            } 
                            svg{
                                width: 28px;
                                height: 28px;
                            }
                            span{
                                font-size: 1.1rem;
                            }
                        }
                        .instagramCount{
                            svg{
                                margin-left: 0px;
                            }
                        }
                        .facebookCount{
                            svg{
                                margin-left: -11px;
                                //margin-right: 0px;
                            }
                        }
                        .tiktokCount{
                            svg{
                                margin-left: -5px;
                            }
                        }
                    }
                }
                .data{
                    width: 510px;
                    .fileName{
                        .name{
                            font-size: 2.4rem;
                        }
                        .checkContainer{
                            width: 23px;
                        }
                        .likeInfluencerContainer{
                            width: 35px;
                            height: 35px;
                        }
                        .likeCompanyContainer{
                            width: 35px;
                        }                 
                    }
                    .firstFile, .lastFile{
                        .item{
                            .city{
                                font-size: 1.2rem;
                            }
                        }
                        .items{
                            .share{
                                .shareIcon{
                                    width: 18px;
                                    height: 18px;
                                }
                            }
                            .subItem{
                                .language{
                                font-size: 1.2rem;
                                }
                                .score{
                                    font-size: 1.1rem;
                                }
                                .star{
                                    width: 18px;
                                    height: 18px;
                                }
                            }
                        }
                        .categories{
                            font-size: 1.1rem;
                        }
                    }
                    .descriptionContainer{
                        .descriptionEmpty{
                            width: 100%;
                            .item{
                                hr{
                                    margin-top: 20px;  
                                }
                                hr:first-child{
                                    margin-top: 5px;  
                                }
                            }

                        }
                        .descriptionContent{
                            p{
                                font-size: 1.1rem;
                            }
                        } 
                    }
                }
            }
            
        }

        .myProfileBody{
            padding:30px 70px 30px 70px ;
            .collaborationsCardsContainer, .galeryCardsContainer,  .productsCardsContainer{ 
                .title{
                    h3{
                        font-size: 2.3rem;
                    }
                }
                .collaborationCards, .galeryCards, .productsCards{
                    .front{
                        .likeProductContainer{
                            top: 15px;
                            right: 15px;
                            width: 30px;
                            height: 30px;   
                        }
                        .productName{
                            //font-size: 1.4rem;
                            font-size: 1.3rem;
                        }
                    }
                    .notContent{
                        height: 250px;
                        p{
                            font-size: 1.1rem;
                        }
                    }
                }
            }
            .productsCardsContainer{
                margin-top: 100px;
                    
            }
        }

    }

    ${media.mediumDesktop}{

        .banner{
            .bannerInformation{
                .networkContainer{
                    .play{
                        width : 50px;
                        height: 50px;
                        top:265px;
                        left: 120px;
                    } 
                    .networks{
                        left: 215px;
                        width: 260px;
                    }
                }
                .data{
                    width: 470px;
                    margin-right: 20px;
                    .fileName{
                        .name{
                            font-size: 2.3rem;
                        }
                        .checkContainer{
                            width: 22px;
                        } 
                        .likeInfluencerContainer{
                            width: 32px;
                            height: 32px;
                        }
                        .likeCompanyContainer{
                            width: 32px;
                        }                
                    }
                    .firstFile, .lastFile{
                        .item{
                            .city{
                                font-size: 1.1rem;
                            }
                        }
                        .items{
                            .share{
                                .shareIcon{
                                    width: 18px;
                                    height: 18px;
                                }
                            }
                            .subItem{
                                .language{
                                font-size: 1.1rem;
                                }
                                .score{
                                    font-size: 1.1rem;
                                }
                                .star{
                                    width: 18px;
                                    height: 18px;
                                }
                            }
                        }
                        .categories{
                            font-size: 1rem;
                        }
                    }
                    .descriptionContainer{
                        .descriptionContent{
                            p{
                                font-size: 1rem;
                            }
                        } 
                    }
                }
            }
        }
        .myProfileBody{
            padding:30px 40px 30px 40px ;
        }
    }

    ${media.smallDesktop}{

        .banner{
            padding: 20px 20px ;
            
            .bannerInformation{
                .networkContainer{
                    .play{
                        width : 50px;
                        height:50px;
                        top:255px;
                        left: 115px;
                    } 
                    .networks{
                        left: 205px;
                        width: 260px;
                        .networkLine{
                            span{
                                font-size:1rem;
                            }
                        }
                        .youtubeCount, .twitterCount, .tiktokCount, .facebookCount, .instagramCount{
                            svg{
                                width: 26px;
                                height: 26px;
                            }
                            span{
                                font-size: 1rem;
                            }
                        }
                        .facebookCount{
                            svg{
                                //margin-right: 0px;
                            }
                        }
                    }
                }
                .data{
                    width: 450px;
                    margin-right: 20px;
                    .fileName{
                        .name{
                            font-size: 2.2rem;
                        }
                        .checkContainer{
                            width: 22px;
                        } 
                        .likeInfluencerContainer{
                            width: 32px;
                            height: 32px;
                        }
                        .likeCompanyContainer{
                            width: 32px;
                        }                
                    }
                    .firstFile, .lastFile{
                        .item{
                            .city{
                                font-size: 1.1rem;
                            }
                        }
                        .items{
                            .share{
                                .shareIcon{
                                    width: 18px;
                                    height: 18px;
                                }
                            }
                            .subItem{
                                .language{
                                font-size: 1.1rem;
                                }
                                .score{
                                    font-size: 1.1rem;
                                }
                                .star{
                                    width: 18px;
                                    height: 18px;
                                }
                            }
                        }
                        .categories{
                            font-size: 1rem;
                        }
                    }
                    .descriptionContainer{
                        .descriptionContent{
                            p{
                                font-size: 1rem;
                            }
                        } 
                    }
                }
            }
            
        }

        .myProfileBody{
            padding:30px 40px 30px 40px ;
            .collaborationsCardsContainer, .galeryCardsContainer,  .productsCardsContainer{ 
                .title{
                    h3{
                        font-size: 2.1rem;
                    }
                }
                .collaborationCards, .galeryCards, .productsCards{
                    .front{
                        .likeProductContainer{
                            top: 12px;
                            right: 12px;
                            width: 28px;
                            height: 28px;   
                        }
                        .productName{
                            font-size: 1.2rem;
                        }
                    }
                }
            }
        }

    }


    ${media.laptop}{
        .banner{
            .goBack{
                margin-left: 30px;
            }
            .bannerInformation{
                flex-direction: column;
                .networkContainer{
                    display: flex;
                    justify-content: center;
                    position: relative;
                    .play{
                        width: 50px;
                        height: 50px;
                        position: absolute;
                        z-index: 100;
                        left: calc(50vw - 50px);
                        top: 255px;
                    }
                    .networks{
                        display: none;
                    }
                }
                .data{
                    margin-right: 0px;
                    width: 80vw;
                    align-self: center;
                    margin-top: 40px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    .fileName{
                        //align-items: center;
                        justify-content: center;
                        text-align: center;
                        width: 100%;
                        .name{
                            font-size: 2.3rem;
                        }
                        .checkContainer{
                            width: 24px;
                            height: 24px;
                        }
                        .likeInfluencerContainer{
                            width: 34px;
                            height: 34px;
                        }
                        .likeCompanyContainer{
                            width: 34px;
                            height: 34px;
                        }
                        
                    }
                    .firstFile, .lastFile{
                        flex-direction: column;
                        font-size: 1.2rem;
                        .star{
                            margin-left: 10px;
                            margin-right: 25px;
                            width: 18px;
                            height: 18px;
                        }
                        .item{
                            display: flex;
                            align-items: center;
                            margin-bottom: 10px;
                            .city{
                                color: ${colors.hightlight};
                                font-size: 1.3rem;
                                font-weight: 600;
                            }
                        }
                        .items{
                            .share{
                                margin-top: 2px;
                                .shareIcon{
                                    width: 17px;
                                    height: 17px;
                                }
                            }
                            .subItem{
                                .language{
                                font-size: 1.3rem;
                                }
                                .score{
                                    font-size: 1.3rem;
                                }
                                .star{
                                    width: 18px;
                                    height: 18px;
                                }
                            }
                        }
                        .categories{
                            color: ${colors.hightlight};
                        }
                    }
                    .descriptionContainer{
                        margin: 10px 0;
                        .descriptionEmpty{
                            .item{
                                display: flex;
                                width: 60vw;
                                flex-direction: column;
                                hr{
                                    margin-bottom: 10px;
                                    
                                }     
                            }
                        }
                        .descriptionContent{
                            width: 80vw;
                            p{
                                font-size: 1rem;
                                text-align: center;
                            }
                        }
                    }
                    .lastFile{
                        flex-direction: row;
                    }

                }
                .networkMobile{
                    display: block;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin: 20px 0;
                    .contentNetwork{
                        display: flex;
                        align-items: center;
                        margin: 0 5px;
                        .network{
                            width: 40px;
                            height: 40px;
                            border-radius: 50%;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                        }
                        .followersCount{
                            display: none;
                        }
                    }
                    
                    .contentNetwork:hover{
                        .network{
                            background-color: #000000;
                            z-index: 50;
                        }
                        .followersCount{
                            display: block;
                            color: #ffffff;
                            padding-left: 15px;
                            padding-right: 10px;
                            margin-left: -10px;
                            margin-right: 5px;
                            background-color: rgba(61, 61, 61, 0.4);
                            border-radius: 0 20px 20px 0;
                        }
                    }
                    
                }
            }
        }  
        .myProfileBody{
            .productsCardsContainer{
                margin-top: 10px;
                  
            }
            
        }  
        
    }

    ${media.tablet}{
        .myProfileBody{
            padding:30px;
            .collaborationsCardsContainer, .productsCardsContainer, .galeryCardsContainer{
                .title{
                    h3{
                        font-size: 2.3rem;
                    }
                }
                .collaborationCards, .galeryCards, .productsCards{
                    .front{
                        width: 31%;
                        height: 28vw;
                        .likeProductContainer{
                            top: 10px;
                            right: 10px;
                        } 
                    }
                } 
            }
        }
    }

    ${media.largeMobile}{
        .banner{
            .goBack{
                margin-left: 10px;
            }
            .bannerInformation{
                .networkContainer{
                    .play{
                        width: 40px;
                        height: 40px;
                        left: calc(50vw - 40px);
                        top: 160px;
                    }
                }
                .data{
                    .fileName{
                        margin-bottom: 15px;
                        width: 90vw;
                        .name{
                            font-size: 1.6rem;
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            //width: 100%;
                        }
                        .checkContainer{
                            width: 18px;
                            height: 18px;
                            margin-left: 10px;
                        }
                        .likeInfluencerContainer{
                            width: 28px;
                            height: 28px;
                            margin-left: 10px;
                        }
                        .likeCompanyContainer{
                            width: 28px;
                            height: 28px;
                            margin-left: 10px;
                        }
                    }
                    .firstFile, .lastFile{
                        flex-direction: column;
                        .star{
                            margin-left: 6px;
                            width: 16px;
                            height: 16px;
                        }
                        .item{
                            .city{
                                font-size: 1.1rem;
                            }
                        }
                        .items{
                            .share{
                                .shareIcon{
                                    width: 18px;
                                }
                            }
                            .subItem{
                                .language{
                                font-size: 1.1rem;
                                }
                                .score{
                                    font-size: 1.1rem;
                                }
                                .star{
                                    width: 18px;
                                    height: 18px;
                                }
                            }
                        }
                        .categories{
                            font-size:1rem;
                        }
                    }
                    .descriptionContainer{
                        margin: 10px 0;
                        .descriptionEmpty{
                            .item{
                                display: flex;
                                width: 60vw;
                                flex-direction: column;
                                hr{
                                    margin-bottom: 5px;
                                    
                                }     
                            }
                        }
                        .descriptionContent{
                            p{
                                font-size: 1rem;
                                display: block;
                                display: -webkit-box;
                                max-width: 100%;
                                max-height: 100px;
                                margin: 0 auto;
                                line-height: 1.3;
                                -webkit-line-clamp: 5;
                                -webkit-box-orient: vertical;
                                overflow: hidden;
                                text-overflow: ellipsis;
                            }
                        }
                    }
                }
            }
        }
        .myProfileBody{
            padding:30px 20px 30px 20px ;
            .collaborationsCardsContainer, .productsCardsContainer, .galeryCardsContainer{
                .title{
                    h3{
                        font-size: 1.8rem;
                        color: ${colors.title};
                    }
                }
                .collaborationCards, .productsCards, .galeryCards{
                    display: flex;
                    .front{
                        width: 48%;
                        height: 41vw;
                        .likeProductContainer{
                            top: 8px;
                            right: 8px;
                            width: 22px;
                            height: 22px;
                        }
                        .productName{
                            font-size: 1rem;
                        }
                        .companyIcon{
                            width: 40px;
                            height: 40px;
                        }
                    }
                }
            }
        }
    }

`

export const ProfileImage = styled.div`

    width: 650px; 
    height: 650px;
    background-image:url(${(props) => props.image});
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: 50%;
    background-position: 50%;
    position: absolute;
    z-index: 50;

    /**--------Responsive-------- */
    ${media.extralargeDesktop}{
        width: 550px; 
        height: 550px;
    }

    ${media.largeDesktop}{
        width: 450px; 
        height: 450px;
    }

    ${media.specialScreen}{
        width: 380px; 
        height: 380px;
    }

    ${media.bigmacdesktop}{
        width: 360px; 
        height: 360px;
    }

    ${media.macdesktop}{
        width: 340px; 
        height: 340px;
    }

    ${media.desktop}{
        width: 300px; 
        height: 300px;
    }

    ${media.mediumDesktop}{
        width: 290px; 
        height: 290px;
    }

    ${media.smallDesktop}{
        width: 280px; 
        height: 280px;
    }

    ${media.laptop}{
        position: initial;
    }

    ${media.largeMobile}{
        width: 180px;
        height: 180px;

    }
`

export const NetworkCount = styled.div`
        position: relative;
        text-align: end;
        width: ${(props) => props.count < networkRanges.rango1 ? '40%' : props.count < networkRanges.rango2 ? '50%' : props.count < networkRanges.rango3 ? '60%' : props.count < networkRanges.rango4 ? '70%' : props.count < networkRanges.rango5 ? '80%' : '90%'};
        height: 80px;
        margin-top: 10px;
        

        /**----------Responsive---------- */
        ${media.extralargeDesktop}{
            width: ${(props) => props.count < networkRanges.rango1 ? '50%' : props.count < networkRanges.rango2 ? '58%' : props.count < networkRanges.rango3 ? '66%' : props.count < networkRanges.rango4 ? '74%' : props.count < networkRanges.rango5 ? '82%' : '90%'};
            height: 70px;
        }

        ${media.largeDesktop}{
            width: ${(props) => props.count < networkRanges.rango1 ? '45%' : props.count < networkRanges.rango2 ? '53%' : props.count < networkRanges.rango3 ? '61%' : props.count < networkRanges.rango4 ? '69%' : props.count < networkRanges.rango5 ? '76%' : '90%'};
            height: 65px;
        }

        ${media.specialScreen}{
            width: ${(props) => props.count < networkRanges.rango1 ? '40%' : props.count < networkRanges.rango2 ? '50%' : props.count < networkRanges.rango3 ? '60%' : props.count < networkRanges.rango4 ? '70%' : props.count < networkRanges.rango5 ? '80%' : '90%'};
            height: 42px;
        }

        ${media.bigmacdesktop}{
            height: 40px;
        }

        ${media.macdesktop}{
            width: ${(props) => props.count < networkRanges.rango1 ? '38%' : props.count < networkRanges.rango2 ? '48%' : props.count < networkRanges.rango3 ? '58%' : props.count < networkRanges.rango4 ? '68%' : props.count < networkRanges.rango5 ? '78%' : '90%'};
            height: 38px;
        }

        ${media.desktop}{

            height: 35px; 
            margin-top: 5px;
        }
        ${media.mediumDesktop}{
            width: ${(props) => props.count < networkRanges.rango1 ? '44%' : props.count < networkRanges.rango2 ? '53%' : props.count < networkRanges.rango3 ? '61%' : props.count < networkRanges.rango4 ? '69%' : props.count < networkRanges.rango5 ? '76%' : '90%'};
            height: 33px;
        }

        ${media.smallDesktop}{
            height: 31px;
        }
                    
`